<ngc-announcement-launcher></ngc-announcement-launcher>
<ngc-content class="ngc-content"></ngc-content>
<ngc-user-audit *ngIf="isSysAdmin"></ngc-user-audit>
